/**Important: to see the full icons list visit: https://react-icons.github.io/react-icons */
import { HiOutlineDocumentText } from "react-icons/hi"; // ! Reports node (in treeview) icon
import { BsFileSpreadsheet } from "react-icons/bs"; // ! Matrix node (in treeview) icon
import { MdTitle } from "react-icons/md"; // ! Title node (in treeview) icon
import { GoGraph } from "react-icons/go"; // 

/*
    To add a new customItem you must add the rule here, specify the type of the item and how it will be rendered.
*/
const types = [
    {
        name: "matrix",
        render: (title) => {
            return (
                <>
                   <span title={title}><BsFileSpreadsheet className="treeview_node_icon" /> {title}</span> 
                </>
            )
        }
    },
    {
        name: "title",
        render: (title) => {
            return (
                <>
                    <span title={title}><MdTitle className="treeview_node_icon" /> {title}</span>
                </>

            )
        }
    },
    {
        name: "report",
        render: (title) => {
            return (
                <>
                    <span title={title}><HiOutlineDocumentText className="treeview_node_icon" /> {title}</span>
                </>

            )
        }
    },
    {
        name: "graph",
        render: (title) => {
            return (
                <>
                    <span title={title}><GoGraph className="treeview_node_icon" /> {title}</span>
                </>

            )
        }
    }
];

const customItem = (params) => {
    //Search if exist the itemType
    const itemType = types.find(type => params.item.type === type.name);

    if (itemType) {
        return itemType.render(params.item.text)
    }

    //default
    return <>{params.item.text}</>
}

export default customItem;